module.exports = __webpack_public_path__ + "img/contact.2fb74dd8.png";